import React from 'react'
import clsx from 'clsx'

export const unUseTitleTypes = ['product']

export const WebField = ({ opts, error, isInline, children }) => {
  const { layouts } = opts
  return !opts.hiddenWhenCreate ? (
    // eslint-disable-next-line react/jsx-no-useless-fragment
    <>
      {unUseTitleTypes.includes(opts.type) ? (
        children
      ) : (
        <div
          className={clsx(
            !isInline && 'text-theme-13 pb-4',
            isInline && 'items-center justify-center font-normal',
            'w-full flex flex-row'
          )}
        >
          {!layouts ? (
            <div>
              {isInline && opts.required ? (
                <span className="font-semibold text-error-500 mr-1">*</span>
              ) : (
                <div className="w-2">
                  {opts.required && (
                    <span className="font-semibold mr-1 text-error-500">*</span>
                  )}
                </div>
              )}
            </div>
          ) : null}

          <div className="w-full flex flex-col relative">
            {!isInline && !layouts && (
              <div className="w-full flex flex-row items-center">
                <h1 form="" className="form-title text-sm">
                  {opts.title}:
                </h1>
              </div>
            )}
            {/* {finalOpts.description && (
          <span
            className="mt-1 hidden"
            style={{ fontSize: '0.75rem', opacity: '0.45' }}
          >
            {finalOpts.description}
          </span>
        )} */}
            {children}
            {error && (
              <span
                className="mt-1 text-error-500"
                style={{ fontSize: '0.75rem' }}
              >
                {error.message}
              </span>
            )}
          </div>
        </div>
      )}
    </>
  ) : (
    <span />
  )
}

export default WebField
